import { render, staticRenderFns } from "./PaywallFormInput.vue?vue&type=template&id=ff571dca&scoped=true"
import script from "./PaywallFormInput.vue?vue&type=script&lang=js"
export * from "./PaywallFormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff571dca",
  null
  
)

export default component.exports